import React, {Component} from "react"
import {BrowserRouter as Router} from "react-router-dom";
import {View, Add, Edit, List, Import} from "./Layouts"
import {Container, UncontrolledAlert} from 'reactstrap';
import "./Assets/css/index.scss";
import "./Assets/css/default-main.css";


class DataTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            api: false,
            item: false,
            showList: false,
            showAdd: false,
            showEdit: false,
            showView: false,
            showImport: false,
            notifications: {}
        }

        this.hideComponent = this.hideComponent.bind(this);
        this.notificationComponent = this.notificationComponent.bind(this);
    }

    componentDidMount() {
        if (this.props.name === null) {
            this.setState({showList: true})
        } else {
            this.hideComponent({component: this.props.name});
        }
    }

    notificationComponent(e) {
        this.setState({notifications: e})
        setTimeout(() => {
            this.setState({
                notifications: {}
            })}, 5000)
    }

    hideComponent(name) {

        switch (name.component) {

            case "showImport":
                this.setState({showImport: true});
                this.setState({showView: false});
                this.setState({showEdit: false});
                this.setState({showList: false});
                this.setState({showAdd: false});
                break;
            case "showView":
                this.setState({showView: !this.state.showView});
                this.setState({showEdit: false});
                this.setState({showList: false});
                this.setState({showAdd: false});
                this.setState({showImport: false});
                break;
            case "showAdd":
                this.setState({showAdd: !this.state.showAdd});
                this.setState({showEdit: false});
                this.setState({showList: false});
                this.setState({showView: false});
                this.setState({showImport: false});
                break;
            case "refreshAdd":
                this.setState({showAdd: false});
                this.setState({showAdd: true});
                this.setState({showEdit: false});
                this.setState({showList: false});
                this.setState({showView: false});
                this.setState({showImport: false});
                break;
            case "showEdit":
                this.setState({showAdd: false});
                this.setState({showEdit: !this.state.showEdit});
                this.setState({showList: false});
                this.setState({showView: false});
                this.setState({showImport: false});
                break;
            case "showList":
                this.setState({showAdd: false});
                this.setState({showEdit: false});
                this.setState({showList: !this.state.showList});
                this.setState({showView: false});
                this.setState({showImport: false});
                break;
            case "refreshList":
                this.setState({showList: false});
                this.setState({showList: true});
                this.setState({showAdd: false});
                this.setState({showEdit: false});
                this.setState({showView: false});
                this.setState({showImport: false});
                break;
        }

        this.setState({
            item: (name.item) ? name.item : false,
            api: (name.api) ? name.api : false,
            return: (name.return) ? name.return : false
        })

    }

    render() {
        const {showAdd, showEdit, showList, showView, showImport} = this.state;
        return (
            <Router>
                {(this.state.notifications.type) &&

                Object.values(this.state.notifications.message).map((value, key) => {
                    const color = (this.state.notifications.type === 'success') ? "success" : "danger"
                    const classAlert = "fade show alert-dismissible-" + key
                    return (
                        <UncontrolledAlert
                            color={color}
                            className={classAlert}
                            role="alert"
                            key={key}>
                            <i className="mdi mdi-block-helper me-2"> </i>
                            {value}
                        </UncontrolledAlert>
                    )
                })

                }

                {(this.props.db) &&

                <Container fluid className="datatable">

                    {showList && <List {...this.props}
                                       hideComponent={this.hideComponent}
                                       notificationComponent={this.notificationComponent}
                                       return={this.state.return}/>}

                    {showAdd && <Add {...this.props}
                                     hideComponent={this.hideComponent}
                                     notificationComponent={this.notificationComponent}
                                     api={this.state.api}
                                     return={this.state.return}/>}

                    {showEdit && <Edit {...this.props}
                                       hideComponent={this.hideComponent}
                                       notificationComponent={this.notificationComponent}
                                       api={this.state.api}
                                       item={this.state.item}
                                       return={this.state.return}/>}

                    {showView && <View {...this.props}
                                       hideComponent={this.hideComponent}
                                       notificationComponent={this.notificationComponent}
                                       api={this.state.api}
                                       id={this.props.id}
                                       return={this.state.return}/>}

                    {showImport && <Import {...this.props}
                                           hideComponent={this.hideComponent}
                                           notificationComponent={this.notificationComponent}
                                           api={this.state.api}
                                           id={this.props.id}
                                           return={this.state.return}/>}


                </Container>

                }

            </Router>
        )
    }
}

export default DataTable